import "./Projects.module.css";
import Header from "@/reusable_sections/Header";
import Showcase from "./sections/Showcase";
import Footer from "./sections/Footer";
export default function ProjectsPage() {
  return <div>
      <Header />
      <Showcase />
      <Footer />
    </div>;
}